import { Injectable } from '@angular/core'
import { IJobSearchRequest, IJobSearchResult } from '@candidate/app/models/jobs/job-search.model'
import { selectors } from '@candidate/app/store/selectors'
import { environment } from '@candidate/environments/environment'
import { isNotNil } from '@engineering11/utility'
import { RestApiClient } from '@engineering11/web-api-rest'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { DEFAULT_NETWORK_MONITORING_CONFIG, getBaseSuffix } from 'shared-lib'

@Injectable({
  providedIn: 'root',
})
export class JobSearchService {
  private client: RestApiClient

  constructor(private store: Store) {
    this.client = new RestApiClient({
      baseUrl: environment.services.jobs,
      token: store.select(selectors.getCurrentToken).pipe(filter(isNotNil)),
      baseSuffix: getBaseSuffix(environment, 'jobs'),
      ...DEFAULT_NETWORK_MONITORING_CONFIG,
    })
  }

  search(request: IJobSearchRequest): Observable<IJobSearchResult> {
    return this.client.post<IJobSearchResult>('/job-posts/search', request).pipe(map(item => item.data))
  }
}
